import { createContext } from 'react';

export const authinitialState = {
  userData: { isLoggedIn: false, referralCode: '' },
  userPoints: {},
  isLoggedIn: false,
  referralCode: '',
  pageFrom: '',
  isDrugPriceLoad: true,
  isServerSessionExpired: false
};
export const AuthContext = createContext(authinitialState);
